import * as React from 'react';
import i18n from 'src/resources/i18n';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import QuickModeOrgUserRegister from '../../containers/QuickModeOrgUserRegister';

/**
 * QuickModeOrgUserRegisterMain画面
 * @param props
 */
const QuickModeOrgUserRegisterMain: React.FunctionComponent<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Rakunavi_Name')} />
			<QuickModeOrgUserRegister {...props} />
		</>
	);
};

export default QuickModeOrgUserRegisterMain;



// WEBPACK FOOTER //
// ./src/pages/personal/QuickModeOrgUserRegisterMain.tsx